import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgProgressbar } from 'ngx-progressbar';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgProgressbar],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-progress color="var(--color-border-focus)" thick="true" [spinner]="false" />
    <router-outlet />
  `,
})
export class AppComponent {}
